import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const FilterInfo = (props) => {
  const {
    className,
    filterInfoText = "Speziell für Lehrkräfte",
    toggleStatus = false,
    count = 0,
    name = "lehrkraefte",
  } = props;
  const componentClassName = "sal-filter-info";
  const componentClass = classnames(componentClassName, className);

  return (
    <span className={componentClass} id={`filter-${name}`} aria-live="polite">
      {filterInfoText} &nbsp;
      <span
        className={
          toggleStatus
            ? "sal-toggle-filters__count--hidden"
            : "sal-toggle-filters__count"
        }
      >
        ({count})
      </span>
    </span>
  );
};

FilterInfo.propTypes = {
  filterInfoText: PropTypes.string.isRequired,
  className: PropTypes.string,
  toggleStatus: PropTypes.bool,
  count: PropTypes.number,
  name: PropTypes.string,
};

export default FilterInfo;
